import PropTypes from 'prop-types';
import cx from 'classnames';
import Conditional from '../../Conditional';
import { CatIconClose } from '@blocks-react/components/Icons/Close';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import styles from './CustomHeaderDrawer.module.scss';

const CustomHeaderDrawer = ({
  headerClassName,
  onBackDrawer,
  onCloseDrawer,
  showBackButton,
  showDivider,
  title,
  maximizeTitleWidth = false
}) => {
  return (
    <>
      <section
        className={cx(
          'd-flex',
          styles['custom-header-drawer__content'],
          headerClassName
        )}
      >
        <section
          className={cx('d-flex', {
            'w-75': !maximizeTitleWidth,
            'flex-grow-1': maximizeTitleWidth
          })}
        >
          <Conditional test={showBackButton}>
            <section className="d-flex justify-content-end align-items-center me-4">
              <CatIconArrowBack
                className={styles['custom-header-drawer__gray-icon']}
                data-testId="cat-icon-arrow-back"
                slot="before"
                onClick={onBackDrawer ? onBackDrawer : onCloseDrawer}
              />
            </section>
          </Conditional>
          <h4
            data-testid="billing-method-drawer"
            className="cat-u-theme-typography-title color-black m-0"
          >
            {title}
          </h4>
        </section>
        <section
          className={cx('d-flex justify-content-end align-items-center', {
            'w-25': !maximizeTitleWidth
          })}
        >
          <CatIconClose
            className={styles['custom-header-drawer__gray-icon']}
            data-testId="cat-icon-close"
            slot="before"
            onClick={onCloseDrawer}
          />
        </section>
      </section>
      <Conditional test={showDivider}>
        <hr
          data-testId="divider"
          className={cx(styles['custom-header-drawer__divider'])}
        />
      </Conditional>
    </>
  );
};

CustomHeaderDrawer.propTypes = {
  headerClassName: PropTypes.string,
  onBackDrawer: PropTypes.func,
  onCloseDrawer: PropTypes.func,
  showBackButton: PropTypes.bool,
  showDivider: PropTypes.bool,
  title: PropTypes.string,
  maximizeTitleWidth: PropTypes.bool
};

export default CustomHeaderDrawer;
